const basePath = '/personal'
export const ROUTER_PERSONAL_DASHBOARD = {
	root: `${basePath}`,
	dashboard: `${basePath}/dashboard`,
	exams_homework: `${basePath}/exams-homework`,
	exams: `${basePath}/exams`,
	favorite_exams: `${basePath}/favorite-exams`
}
